import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';

const H2Element = ({ element }) => {
  const { replaceTemplates } = useOnboarding();
  const style = applyStyles(element);

  return (
    <h2 className="element-h2" style={style}>
      {replaceTemplates(element.text)}
    </h2>
  );
};

export default H2Element;

